import Vue from 'vue';
import Vuex from 'vuex';
import im from './im';
Vue.use(Vuex);

const store = new Vuex.Store({
    modules:{
        im
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js